import React from 'react';

const FAQSection = () => {
  return (
    <section className="bg-elion-beige text-elion-navy py-16">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10">
          Perguntas Frequentes
        </h2>
        <div className="space-y-4">
          {[
            {
              pergunta: 'Como funciona a Sociedade Imobiliária Elion?',
              resposta:
                'Você terá acesso a uma plataforma completa que permite gerenciar seus imóveis, criar sua vitrine online e conectar-se com outros profissionais para maximizar seus resultados.',
            },
            {
              pergunta: 'Como funciona o sistema de comissões?',
              resposta:
                'Você mantém 100% das suas comissões. Não cobramos percentual sobre suas vendas.',
            },
            {
              pergunta: 'Como posso começar?',
              resposta:
                'Basta clicar no botão de cadastro, criar sua conta e ativar seu acesso em poucos minutos.',
            },
            {
              pergunta: 'A garantia de 7 dias é real?',
              resposta:
                'Sim! Você tem 7 dias para testar a plataforma e se não gostar, pode cancelar sem custo.',
            },
          ].map((faq, idx) => (
            <details
              key={idx}
              className="bg-white rounded-lg shadow p-4 cursor-pointer"
            >
              <summary className="font-medium">{faq.pergunta}</summary>
              <p className="mt-2 text-elion-dark">{faq.resposta}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
